// extracted by mini-css-extract-plugin
export default {"middleStats":"MiddleStats_middleStats__UO3zo","stat":"MiddleStats_stat__eivmD"};